export default {prompt:"Link Hover Effect?",
field:"linkHover",
type:"class",
default:"none",
options:[
    {value:"none",text:"None"},
    {value:"underline",text:"Underline"},
]
}